/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesProfileFetchFxIdGameConnectionRequest
 */
export interface FxIdWebFeaturesProfileFetchFxIdGameConnectionRequest {
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesProfileFetchFxIdGameConnectionRequest
     */
    GameSystemName: string;
}

/**
 * Check if a given object implements the FxIdWebFeaturesProfileFetchFxIdGameConnectionRequest interface.
 */
export function instanceOfFxIdWebFeaturesProfileFetchFxIdGameConnectionRequest(value: object): value is FxIdWebFeaturesProfileFetchFxIdGameConnectionRequest {
    if (!('GameSystemName' in value) || value['GameSystemName'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesProfileFetchFxIdGameConnectionRequestFromJSON(json: any): FxIdWebFeaturesProfileFetchFxIdGameConnectionRequest {
    return FxIdWebFeaturesProfileFetchFxIdGameConnectionRequestFromJSONTyped(json, false);
}

export function FxIdWebFeaturesProfileFetchFxIdGameConnectionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesProfileFetchFxIdGameConnectionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'GameSystemName': json['GameSystemName'],
    };
}

export function FxIdWebFeaturesProfileFetchFxIdGameConnectionRequestToJSON(json: any): FxIdWebFeaturesProfileFetchFxIdGameConnectionRequest {
    return FxIdWebFeaturesProfileFetchFxIdGameConnectionRequestToJSONTyped(json, false);
}

export function FxIdWebFeaturesProfileFetchFxIdGameConnectionRequestToJSONTyped(value?: FxIdWebFeaturesProfileFetchFxIdGameConnectionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'GameSystemName': value['GameSystemName'],
    };
}

